module.exports = __webpack_public_path__ + "img/3.0819bfe8.png";